<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-astats-body">
            <div class="dw-astats-hero">
                <span class="dw-astats-hero-num">{{ data.total }}</span>
                <span class="dw-astats-hero-lbl">Toplam Randevu</span>
            </div>
            <div class="dw-astats-bar-section">
                <div class="dw-astats-bar">
                    <div class="dw-astats-bar-fill dw-astats-bar-fill--ok" :style="{ width: completedPercent + '%' }"></div>
                </div>
            </div>
            <div class="dw-metrics">
                <div class="dw-metric">
                    <i class="bi bi-check-circle-fill" style="color: var(--bs-success)"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val">{{ data.completed }}</span>
                        <span class="dw-metric-lbl">Tamamlanan</span>
                    </div>
                </div>
                <div class="dw-metric-sep"></div>
                <div class="dw-metric">
                    <i class="bi bi-clock-fill" style="color: var(--bs-warning)"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val">{{ data.pending }}</span>
                        <span class="dw-metric-lbl">Bekleyen</span>
                    </div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'agenda_stats',
    titleKey: 'common.dashboard.widgetTitles.agenda_stats',
    icon: 'bi-bar-chart-line',
    accent: 'var(--bs-info)',
    accentBg: 'rgba(var(--bs-info-rgb, 114, 57, 234), 0.12)',
    glassRgb: '114, 57, 234',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'module', moduleCode: 'AGENDA', code: 'DAILY_SUMMARY' },
};

export default {
    name: 'AgendaStatsWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        data() {
            return this.apiData || { total: 0, completed: 0, pending: 0 };
        },
        completedPercent() {
            if (!this.data.total) return 0;
            return Math.round((this.data.completed / this.data.total) * 100);
        },
    },
};
</script>
